import React, { useState, useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BlogContext } from '../../context/BlogContext';
import { AuthContext } from '../../context/AuthContext';
import { Container, Card, Form, Spinner } from 'react-bootstrap';
import '../../style/Blog.css';

const BlogForm = () => {
  const { user, userLoaded } = useContext(AuthContext);
  const { addBlog, editBlog, blogs } = useContext(BlogContext);
  const { id } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  useEffect(() => {
    if (userLoaded && !user) {
      navigate('/login');
    }
  }, [user, userLoaded, navigate]);

  useEffect(() => {
    if (id) {
      const blogToEdit = blogs.find(blog => blog._id === id);
      if (blogToEdit) {
        setTitle(blogToEdit.title);
        setContent(blogToEdit.content);
      }
    }
  }, [id, blogs]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const blogData = { title, content };
    let blogId;

    if (id) {
      await editBlog(id, blogData);
      blogId = id;
    } else {
      blogId = await addBlog(blogData);
    }

    navigate(`/posts/${blogId}`);
  };

  if (!userLoaded) {
    return <div className="text-center mt-5"><Spinner animation="border" variant="dark" /></div>;
  }

  const isFormValid = title.trim() && content.trim();

  return (
    <Container className="mt-5 mb-4">
      <div className="retro-window">
        <div className="window-dots">
          <span className="dot red" />
          <span className="dot yellow" />
          <span className="dot green" />
        </div>
        <h1 className="text-center mb-4">{id ? 'Edit Post' : 'New Post'}</h1>
      </div>

      <Card className="retro-post-card p-4">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Title</Form.Label>
            <Form.Control
              type="text"
              value={title}
              onChange={e => setTitle(e.target.value)}
              required
              placeholder="Enter post title here"
              className="shadow-sm"
            />
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">Content</Form.Label>
            <Form.Control
              as="textarea"
              rows={7}
              value={content}
              onChange={e => setContent(e.target.value)}
              required
              placeholder="Write your post content here"
              className="shadow-sm"
            />
          </Form.Group>
          <button
            type="submit"
            className="retro-button w-25 text-center justify-content-center mx-auto d-flex"
            disabled={!isFormValid}
          >
            Post
          </button>
        </Form>
      </Card>
    </Container>
  );
};

export default BlogForm;
